import {FC, useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {RootState} from '../../../../setup'
import * as auth from './AuthRedux'

type Props = {
  children: React.ReactNode
}

const AuthInit: FC<Props> = ({children}) => {
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  const accessToken = useSelector(
    (state: RootState) => state.auth.accessToken
  )

  const user = useSelector(
    (state: RootState) => state.auth.user
  )

  useEffect(() => {
    if (!accessToken) {
      setShowSplashScreen(false)
      return
    }
    setTimeout(() => {
      dispatch(auth.actions.requestUser())
    },0)
    setShowSplashScreen(false)
  }, [accessToken, dispatch])
  

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export default AuthInit